module.exports = __webpack_public_path__ + "static/media/iLabDx-Logo.ac7e47e6.png";